/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperatorValidationRequestDTO
 */
export interface OperatorValidationRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof OperatorValidationRequestDTO
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatorValidationRequestDTO
     */
    password?: string;
}

/**
 * Check if a given object implements the OperatorValidationRequestDTO interface.
 */
export function instanceOfOperatorValidationRequestDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OperatorValidationRequestDTOFromJSON(json: any): OperatorValidationRequestDTO {
    return OperatorValidationRequestDTOFromJSONTyped(json, false);
}

export function OperatorValidationRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorValidationRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function OperatorValidationRequestDTOToJSON(value?: OperatorValidationRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'password': value.password,
    };
}

